import { Form, GoogleLogin, LinkedInLogin } from '@/components';
import { useEffect, useState } from 'react';
import { ButtonListWrapper, DividedLine, DividedText, JoinUsWrapper } from './JoinUs.styles';

import { type IPanel, LoginMethod } from '@/interfaces';

import { CheckboxField, EmailField, SignUpSource } from '@/constants';

const JoinUs: React.FC<IPanel> = ({ onStepSuccess, onStepClick, isFullScreen }) => {
  const [currentLoginMethod, setCurrentLoginMethod] = useState<LoginMethod | null>(null);

  const linkedInLoginButtonProps = {
    shouldReloadAfterSuccess: false,
    customHandleSuccess: () => {
      onStepSuccess?.({ authenticationMethod: LoginMethod.LinkedIn });
    },
    customHandleClick: () => {
      onStepClick?.({ authenticationMethod: LoginMethod.LinkedIn });
      setCurrentLoginMethod(LoginMethod.LinkedIn);
    },
  };

  const googleLoginButtonProps = {
    shouldReloadAfterSuccess: false,
    customHandleSuccess: () => {
      onStepSuccess?.({ authenticationMethod: LoginMethod.Google });
    },
    customHandleClick: () => {
      onStepClick?.({ authenticationMethod: LoginMethod.Google });
      setCurrentLoginMethod(LoginMethod.Google);
    },
  };

  const onEmailButtonClicksSuccess = () => {
    if (!onStepClick || !onStepSuccess) {
      return;
    }

    onStepClick({ authenticationMethod: LoginMethod.Email });
    onStepSuccess();
  };

  useEffect(() => {
    return () => setCurrentLoginMethod(null);
  }, []);

  const DividedBar = () => (
    <DividedLine>
      <DividedText>OR</DividedText>
    </DividedLine>
  );

  const CustomEmailField = {
    ...EmailField,
    onClick: () => setCurrentLoginMethod(LoginMethod.Email),
  };

  const CustomCheckboxField = {
    ...CheckboxField,
    appear: currentLoginMethod === LoginMethod.Email,
  };

  return (
    <JoinUsWrapper isFullScreen={isFullScreen}>
      <ButtonListWrapper>
        <LinkedInLogin {...linkedInLoginButtonProps} />
        <br />
        <GoogleLogin {...googleLoginButtonProps} />
      </ButtonListWrapper>
      <DividedBar />
      <Form
        formFieldList={[CustomEmailField, CustomCheckboxField]}
        buttonText='Continue'
        isEmailForm={true}
        onSuccess={onEmailButtonClicksSuccess}
        signUpSource={SignUpSource.Insights}
      />
    </JoinUsWrapper>
  );
};

export default JoinUs;
